export const joinBreadcrumbLabel = (labels: string[]): string => labels.join(' / ');
